import { getPortalName } from "@capone/common";

// TODO: Remove capital one constants
export const CAPITAL_ONE_LABEL = `${getPortalName()}`;
export const HOTEL_CONFIRMATION_LABEL = "Hotel Confirmation";
export const CAPITAL_ONE_WEBSITE = "https://www.capitalonetravel.com/";
export const RETURN_TEXT = "Return";
export const CONFIRMATION_TITLE = "Confirmation Numbers";
export const MODAL_SUBTITLE = `This confirmation code is directly from the hotel`;
